import { render, staticRenderFns } from "./TipoLicencia.vue?vue&type=template&id=2c8ba202&"
import script from "./TipoLicencia.vue?vue&type=script&lang=ts&"
export * from "./TipoLicencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports